import Swiper from 'swiper/bundle'

export default {
  init() {
    const gallery = document.querySelector('.ugo-gallery')
    const galleryThumb = document.querySelector('.ugo-gallery-thumb')

    const galleryThumbSwiper = new Swiper(
      galleryThumb.querySelector('.swiper-container'),
      {
        // loop: false,
        spaceBetween: 0,
        slidesPerView: 4,
        freeMode: true,
        // centeredSlides: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 6,
          },
        },
      }
    )

    const gallerySwiper = new Swiper(gallery, {
      lazy: {
        loadPrevNext: true,
      },
      // init: false,
      // loop: false,
      pagination: {
        el: '.ugo-gallery-thumb-pagination',
        type: 'fraction',
      },
      effect: 'fade',
      speed: 800,
      autoHeight: true,
      grabCursor: true,
      spaceBetween: 0,
      preventClicksPropagation: false,
      thumbs: {
        swiper: galleryThumbSwiper,
      },
      navigation: {
        nextEl: galleryThumb.querySelector('.next'),
        prevEl: galleryThumb.querySelector('.prev'),
      },
    })
  },
}
